


export enum TableFieldType {

    Text = "text",
    Number = "number",
    ColumnSelect = "column_select",
    ColumnSelectOrCreate = "column_select_or_create",
    Boolean = "boolean",
    Select = "select",
    SelectJson = "select_json",
    SelectOrCreate = "select_or_create",
    MultiSelect = "multiselect",
    ColumnMultiSelect = "column_multiselect",
    ColumnMultiSelectOrCreate = "column_multiselect_or_create",
    ArrayValues = "array_values",
    Array = "array",
    Object = "object",
    Json = "json",
    ColorPicker = "color_picker",
    RegularExpression = "regex",
    StringTemplate = "string_template",
    ParamSelect = "param_select",
    ParamSelectOrCreate = "param_select_or_create",
    ParamMultiSelect = "param_multiselect",
    ParamMultiSelectOrCreate = "param_multiselect_or_create",
    ParamOrColumnSelect = "param_or_column_select",
    ParamOrColumnSelectOrCreate = "param_or_column_select_or_create",
    ParamOrColumnMultiSelect = "param_or_column_multiselect",
    ParamOrColumnMultiSelectOrCreate = "param_or_column_multiselect_or_create",
    SelectDataSource = "select_datasource",
    TableColumnTypeSelect = "table_column_type_select"
}